import * as React from 'react';

const LockIcon = ({fillColor = '#2D275650'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 14 16"
    fill="none">
    <path
      fill={fillColor}
      d="M2.345 15.973c-.407 0-.756-.145-1.045-.434a1.425 1.425 0 0 1-.433-1.045V6.821c0-.408.145-.756.433-1.045a1.425 1.425 0 0 1 1.045-.434h.975V3.707c0-1.021.358-1.89 1.074-2.606C5.11.385 5.98.027 7 .027s1.89.358 2.606 1.074c.716.716 1.074 1.585 1.074 2.606v1.635h.975c.407 0 .756.145 1.045.434.288.289.433.637.433 1.045v7.673c0 .408-.145.757-.433 1.046a1.424 1.424 0 0 1-1.045.433h-9.31Zm0-1.227h9.31a.245.245 0 0 0 .18-.07.245.245 0 0 0 .071-.182V6.821a.245.245 0 0 0-.07-.181.245.245 0 0 0-.181-.071h-9.31a.245.245 0 0 0-.18.07.245.245 0 0 0-.071.182v7.673c0 .074.023.134.07.181.048.047.108.071.181.071ZM7 12.088c.397 0 .735-.139 1.014-.417a1.38 1.38 0 0 0 .417-1.013c0-.398-.14-.736-.417-1.014A1.38 1.38 0 0 0 7 9.227c-.397 0-.735.139-1.014.417a1.38 1.38 0 0 0-.417 1.014c0 .397.14.735.417 1.013A1.38 1.38 0 0 0 7 12.09ZM4.547 5.342h4.906V3.707c0-.681-.238-1.26-.715-1.738A2.366 2.366 0 0 0 7 1.254c-.681 0-1.26.238-1.738.715a2.366 2.366 0 0 0-.715 1.738v1.635Z"
    />
  </svg>
);

export default LockIcon;
